import type { PortalThunk } from '../../index'
import { portalAction } from '../../index'
import { AuthorisationResponse, ConfirmAccessResponse, OAuthHttpRequest } from '../../../model'

const BASE_URL = '/portal/consumers/oauth'

export const confirmAccessCheckout: PortalThunk<OAuthHttpRequest, ConfirmAccessResponse> = portalAction(
  'oauth/confirm-access-checkout',
  async (request, thunk) => {
    return await thunk.extra.portalApi().get(`${BASE_URL}/confirm-access-checkout`, {}, request)
  }
)

export const fetchOAuthCode: PortalThunk<OAuthHttpRequest, AuthorisationResponse> = portalAction('oauth/authorize', async (request, thunk) => {
  return await thunk.extra.portalApi().post(`${BASE_URL}/authorize`, request)
})

export const resetOAuthConsumerTags: PortalThunk<void, void> = portalAction('oauth/consumerTags/reset', async (_, thunk) => {
  return await thunk.extra.portalApi().delete(`${BASE_URL}/tags/reset`)
})

export const increaseOAuthRejectionCounter: PortalThunk<void, void> = portalAction('oauth/consumerTags/increaseRejectionCounter', async (_, thunk) => {
  return await thunk.extra.portalApi().post(`${BASE_URL}/tags/increase-rejection-counter`, {})
})
